import { render, staticRenderFns } from "./DialogButtonStyle.vue?vue&type=template&id=dceb990a"
import script from "./DialogButtonStyle.vue?vue&type=script&lang=js"
export * from "./DialogButtonStyle.vue?vue&type=script&lang=js"
import style0 from "./DialogButtonStyle.vue?vue&type=style&index=0&id=dceb990a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports